import { fetcher } from "helpers/fetcher";

import {
  TUpdateEmployeeBasicInfoReq,
  TUpdateEmployeeBasicInfoRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeBasicInfo = async (
  payload: TUpdateEmployeeBasicInfoReq
) => {
  return await fetcher<
    TUpdateEmployeeBasicInfoRes,
    TUpdateEmployeeBasicInfoReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_BASIC_INFO, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_EMPLOYEE_BASIC_INFO.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateEmployeeBasicInfo = async (
  payload: TUpdateEmployeeBasicInfoReq
) => {
  return (await updateEmployeeBasicInfo(payload)).data;
};

mutationUpdateEmployeeBasicInfo._key = (
  payload: TUpdateEmployeeBasicInfoReq
) => [ENDPOINT.USER.UPDATE_EMPLOYEE_BASIC_INFO.url, payload];
